/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_billing = /** @type {(inputs: {}) => string} */ () => {
	return `Fakturace`
};

const da_billing = /** @type {(inputs: {}) => string} */ () => {
	return `Fakturering`
};

const de_billing = /** @type {(inputs: {}) => string} */ () => {
	return `Rechnung`
};

const en_billing = /** @type {(inputs: {}) => string} */ () => {
	return `Billing`
};

const es_billing = /** @type {(inputs: {}) => string} */ () => {
	return `Facturación`
};

const fr_billing = /** @type {(inputs: {}) => string} */ () => {
	return `Facturation`
};

const hu_billing = /** @type {(inputs: {}) => string} */ () => {
	return `Számlázás`
};

const it_billing = /** @type {(inputs: {}) => string} */ () => {
	return `Fatturazione`
};

const nl_billing = /** @type {(inputs: {}) => string} */ () => {
	return `Facturatie`
};

const pl_billing = /** @type {(inputs: {}) => string} */ () => {
	return `Fakturowanie`
};

const pt_billing = /** @type {(inputs: {}) => string} */ () => {
	return `Faturamento`
};

const sv_billing = /** @type {(inputs: {}) => string} */ () => {
	return `Fakturering`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const billing = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.billing(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("billing", locale)
	if (locale === "cs") return cs_billing(inputs)
	if (locale === "da") return da_billing(inputs)
	if (locale === "de") return de_billing(inputs)
	if (locale === "en") return en_billing(inputs)
	if (locale === "es") return es_billing(inputs)
	if (locale === "fr") return fr_billing(inputs)
	if (locale === "hu") return hu_billing(inputs)
	if (locale === "it") return it_billing(inputs)
	if (locale === "nl") return nl_billing(inputs)
	if (locale === "pl") return pl_billing(inputs)
	if (locale === "pt") return pt_billing(inputs)
	return sv_billing(inputs)
};